import { gql } from '@apollo/client';

export const UPDATE_PURCHASE_LINE = gql`
  mutation UPDATE_PURCHASE_LINE($registrationId: String, $purchaseLineId: Int!, $quantity: Int!) {
    updatePurchaseLine: opsPurchaseline(registrationId: $registrationId) {
      purchaseLine: update(purchaseLineId: $purchaseLineId, quantity: $quantity)
    }
  }
`;
